import { component } from 'picoapp';
import toggleAddToCartBtn from '../../js/lib/add-to-cart-btn';
import { addVariant } from '../../js/lib/cart'; // eslint-disable-line

export default component((node) => {
  /**
   * Data + elements
   */
  const addBtn = node.querySelector('.js-addBtn');
  const select = node.querySelector('.js-select');
  const { variantId } = node.dataset;

  /**
   * Functions
   */
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      toggleAddToCartBtn(addBtn, false);

      addVariant({
        variantId,
        quantity: 1,
        callback: () => toggleAddToCartBtn(addBtn, true),
      });
    });
  }

  if (select) {
    const label = node.querySelector('label');
    select.addEventListener('change', () => {
      select.classList.add('hidden');
      label.classList.remove('hidden');
      toggleAddToCartBtn(label, false);

      const { value } = select;
      addVariant({
        variantId: value,
        quantity: 1,
        callback: () => {
          toggleAddToCartBtn(label, true);
          label.classList.add('hidden');
          select.classList.remove('hidden');
        },
      });
    });
  }
});
